import styled from "styled-components";
import React from "react";
import { UserPassword } from "../../assets/User/UserPassword";
import userPic from "../../assets/User/usersuccess.svg"
import { useHistory } from "react-router-dom";
import { TextBtn } from "../../components/inputs/TextBtn";

const StyleCss = styled.div`
  .content {
    .container {
      width: 40%;
      min-width: 300px;
      display: flex;
      flex-direction: column;
      margin: 100px auto 0;
      text-align: center;
      .image {
        display: flex;
        justify-content: center;
      }
      .text {
        margin: 1.5rem 0;
        font-size: 24px;
      }
      .btn {
        margin: 1rem 0 2rem;
      }
    }
  }
`;

function ChangePasswordSuccess(props) {
  const history = useHistory()
  const push = () => {
    history.push('/profile/personal-data')
  }
  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
          <div className="icon"><UserPassword/></div>
          <div className="text">تغییر رمز عبور</div>
          </div>
      </div>
      <div className="content">
        <div className="container">
          <div className="image">
            <img src={userPic} alt="success"/>
          </div>
          <div className="text">
            تغییر رمز عبور با موفقیت انجام شد.
          </div>
          <div className="btn">
              <TextBtn
                text={"بازگشت به اطلاعات شخصی"}
                type={""}
                onclick={push}
              />
          </div>
        </div>
      </div>
    </StyleCss>
);
}
export default ChangePasswordSuccess;